// Этот файл генерируется автоматически, его не следует редактировать вручную
import blogFilter from '@/widgets/blogFilter.js';
import calculator from '@/widgets/calculator.js';
import collapse from '@/widgets/collapse.js';
import form from '@/widgets/form.js';
import headerBlock from '@/widgets/headerBlock.js';
import mobileMenu from '@/widgets/mobileMenu.js';
import mobileMenuButton from '@/widgets/mobileMenuButton.js';
import sliderMain from '@/widgets/sliderMain.js';
import sliderVideo from '@/widgets/sliderVideo.js';
import testBlock from '@/widgets/testBlock.js';
import videoBlock from '@/widgets/videoBlock.js';

export default {
  'blogFilter': async () => { return { default: blogFilter }; },
  'calculator': async () => { return { default: calculator }; },
  'collapse': async () => { return { default: collapse }; },
  'folder': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/folder.js'),
  'form': async () => { return { default: form }; },
  'headerBlock': async () => { return { default: headerBlock }; },
  'mobileMenu': async () => { return { default: mobileMenu }; },
  'mobileMenuButton': async () => { return { default: mobileMenuButton }; },
  'scrollTop': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/scrollTop.js'),
  'sliderMain': async () => { return { default: sliderMain }; },
  'sliderVideo': async () => { return { default: sliderVideo }; },
  'testBlock': async () => { return { default: testBlock }; },
  'upload': async () => await import( /* webpackMode: "lazy-once" */ '@/widgets/upload.js'),
  'videoBlock': async () => { return { default: videoBlock }; }
};
